import basicController from "servicestack/basic.controller.properties";

export default class ParserPromptController {
  constructor(options) {
    console.debug("ParserPromptController", { that: this, options });
    const $ctrl = this;
    basicController($ctrl);
    Object.assign($ctrl, options);
  }

  submit() {
    const $ctrl = this;
    const memo = {};
    const tokens = ($ctrl.tokens || "")
      .split($ctrl.delimiter || new Date().getTime().toString())
      .filter((sku) => !!sku);
    tokens.forEach((sku) => (memo[sku] = true));
    $ctrl.$close(Object.keys(memo));
  }

  $onDestroy() {}
}
